module.exports = __webpack_public_path__ + "img/settings.67172447.svg";